<template>
  <div>
    <div>
      <h1>Sample Page</h1>
      
      <div class='samples'>
        <BootStrapTableSample/>
        <SignupSample/>
        <SigninSample/>
        <PopupSample/>
        <button @click="$router.push({path: '/sample_editor'})">글쓰기</button>
        <button @click="$router.push({path:'/sample_noticeDetail', params: {idx: 1}})">상세보기</button>
        <PostcodeSample/>
        <DownloadSample/>
        <BlockUISample/>
      </div>
    </div>
  </div>
</template>

<script>
import BootStrapTableSample from './BootStrapTableSample.vue'
import SignupSample from './SignupSample.vue'
import SigninSample from './SigninSample.vue'
import PopupSample from './PopupSample.vue'
import PostcodeSample from './PostcodeSample.vue'
import DownloadSample from './DownloadSample.vue'
import BlockUISample from './BlockUISample.vue'

export default {
  name: 'Sample',
  components:{
    BootStrapTableSample,
    SignupSample,
    SigninSample,
    PopupSample,
    PostcodeSample,
    DownloadSample,
    BlockUISample
  }
}
</script>

<style scoped lang="scss">
  .samples::v-deep h3{
    margin-top: 50px;
  }
</style>


